import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRouter, RouterProvider } from '@tanstack/react-router';

import './index.css';
import { queryClient } from './config';
import { routeTree } from './routeTree.gen';
import { OrgTimezoneProvider } from './lib/timezone';
import { AuthProvider } from './lib/auth/AuthContext';
import { ThemeProvider } from './components/providers/ThemeProvider';
import { PageHeaderProvider } from './components/layout/PageHeaderContext';

// Create router instance
const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 10000,
  context: {
    queryClient,
  },
});

// Register router for TypeScript
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Render application
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <ThemeProvider>
        <AuthProvider>
          <QueryClientProvider client={queryClient}>
            <OrgTimezoneProvider>
              <PageHeaderProvider>
                <RouterProvider router={router} />
              </PageHeaderProvider>
            </OrgTimezoneProvider>
            {/* DEV only. This was unconditional, so the devtools badge and the
                full query cache — patient and encounter payloads included —
                shipped to production. TanStackRouterDevtools in __root.tsx was
                already gated this way. */}
            {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
          </QueryClientProvider>
        </AuthProvider>
      </ThemeProvider>
    </React.StrictMode>,
  );
}
